import EmptyScreen from "../../Equity/EmptyScreen/EmptyScreen";
import unsortedIcon from "../../../../assets/images/png/upDown.png";
import sortedIcon from "../../../../assets/images/png/sortedIcon.png";
import sortedAtoz from "../../../../assets/images/png/descSortIcon.png";
import AnalyticsStore from "../../../../store/AnalyticsStore";
import { commaSeperated2, displayUnit } from "../../../../utils/functions";

const Table = ({
  tableData,
  handleSort,
  currentSortKey,
  order,
  instrumentData,
  dropdownCount,
}) => {
  const handleSorting = (sortField, sortOrder) => {
    if (tableData && sortField !== "value") {
      const sorted = tableData.sort((a, b) => {
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      tableData = sorted;
    } else {
      const sorted = tableData.sort(function (a, b) {
        var textA = a.valueType.toUpperCase();
        var textB = b.valueType.toUpperCase();
        return (
          (textA < textB ? -1 : textA > textB ? 1 : 0) *
          (sortOrder === "asc" ? 1 : -1)
        );
      });
      tableData = sorted;
    }
  };

  if (order == null) {
    handleSorting("days_held", "desc");
  }

  return (
    <div>
      {tableData.length > 0 ? (
        <div class="portfolio_ageing_table_component">
          <div class="headers">
            <p class="inst_name" onClick={() => handleSort("instrument_name")}>
              Instrument Name{" "}
              <img
                src={
                  currentSortKey === "instrument_name" && order === "asc"
                    ? sortedIcon
                    : currentSortKey === "instrument_name" && order === "desc"
                    ? sortedAtoz
                    : unsortedIcon
                }
                alt=""
              />
            </p>
            <p onClick={() => handleSort("days_held")}>
              Days Held{"  "}
              <img
                className="sort_icon"
                src={
                  currentSortKey === ""
                    ? sortedAtoz
                    : currentSortKey === "days_held" && order === "asc"
                    ? sortedIcon
                    : currentSortKey === "days_held" && order === "desc"
                    ? sortedAtoz
                    : unsortedIcon
                }
                alt=""
              />
            </p>
            <p onClick={() => handleSort("quantity")}>
              Quantity{" "}
              <img
                className="sort_icon"
                src={
                  currentSortKey === "quantity" && order === "asc"
                    ? sortedIcon
                    : currentSortKey === "quantity" && order === "desc"
                    ? sortedAtoz
                    : unsortedIcon
                }
                alt=""
              />
            </p>
            <p onClick={() => handleSort("value")}>
              Value{" "}
              <img
                className="sort_icon"
                src={
                  currentSortKey === "value" && order === "asc"
                    ? sortedIcon
                    : currentSortKey === "value" && order === "desc"
                    ? sortedAtoz
                    : unsortedIcon
                }
                alt=""
              />
            </p>
            <p className="term_name" onClick={() => handleSort("term")}>
              Term{" "}
              <img
                className="sort_icon"
                src={
                  currentSortKey === "term" && order === "asc"
                    ? sortedIcon
                    : currentSortKey === "term" && order === "desc"
                    ? sortedAtoz
                    : unsortedIcon
                }
                alt=""
              />
            </p>
          </div>
          {tableData.slice(0, dropdownCount)?.map((data) => {
            let valArr = data.value.split(" ");
            return (
              <div class="port_data">
                <div
                  class="color-div"
                  style={{
                    minWidth: `${(data.relativeReturnPercentage / 100) * 100}%`,
                  }}
                ></div>
                <p
                  class="inst_name"
                  style={{
                    color: "#060F1F",
                    fontFamily: "Encode Sans",
                    fontWeight: 600,
                    fontSize: "14px",
                    lineHeight: "18.2px",
                  }}
                >
                  {data.instrument_name}
                </p>
                <p
                  style={{
                    color: "#060F1F",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "21.6px",
                  }}
                >
                  {commaSeperated2(data.days_held)}
                </p>
                <p
                  style={{
                    color: "#060F1F",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "21.6px",
                  }}
                >
                  {commaSeperated2(data.quantity)}
                </p>
                <p
                  style={{
                    color: "#060F1F",
                    fontSize: "14px",
                    lineHeight: "21.6px",
                  }}
                >
                  <span style={{ fontFamily: "Roboto", fontWeight: 500 }}>
                    {commaSeperated2(valArr[0])}
                  </span>{" "}
                  <span
                    style={{
                      fontFamily: "Encode Sans",
                      fontWeight: 400,
                      textTransform: "capitalize",
                    }}
                  >
                    {displayUnit(valArr[1])}
                  </span>
                </p>
                <p
                  style={{
                    fontFamily: "Encode Sans",
                    fontWeight: 600,
                    fontSize: "12px",
                    lineHeight: "15.6px",
                  }}
                  className="term_name term_name_data"
                >
                  {data.term ? data.term : "-"}
                </p>
              </div>
            );
          })}
        </div>
      ) : (
        <>
          <EmptyScreen
            loading={AnalyticsStore.overall.portfolioAgeingLoading}
          />
        </>
      )}
    </div>
  );
};

export default Table;
